import React, {useMemo, useEffect} from 'react';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {Table, Popup} from 'semantic-ui-react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Filter, DefaultColumnFilter} from '../../../common/components/tableFilters';
import {shortYearDate} from '../../../common/constants/datesFormat';
import TablePagination from '../../../common/components/reactTablePagination/index';

const columnsTableWithProps = (props) => {
  return [
    {
      'Header': 'CODIGO',
      'accessor': 'bulletinId',
    },
    {
      'Header': 'MODELO',
      'accessor': 'model',
    },
    {
      'Header': 'ASUNTO',
      'accessor': 'subject',
    },
    {
      'Header': 'FECHA DE PUBLICACION',
      'accessor': 'createdDate',
      'Cell': ({row}) => {
        const {createdDate} = row.original;
        return moment(createdDate).format(shortYearDate);
      },
    },
    {
      'Header': 'USUARIO',
      'accessor': 'createdUser',
    },
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'Cell': ({row}) => {
        const {bulletinId, type} = row.original;
        const bulletinType = type === 'TMC' ? 'TMC' : 'servicio';
        return (
          <Popup
            trigger={
              <Link to={`/boletines/${bulletinType}/editar/${bulletinId}`} target="_blank">
                <span className="link">
                  <i className="material-icons" disabled={props.loading}>
                    visibility
                  </i>
                </span>
              </Link>
            }
            content="Ver Boletín"
            position="top center"
            inverted
          />
        );
      },
    },
  ];
};

const QueryTable = (props) => {
  const {list, selectedStatus, handleChange, filteredRows} = props;
  const columnsTable = columnsTableWithProps(props);
  const data = useMemo(() => list, [list]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    if (rows.length !== filteredRows.length) {
      handleChange('filteredRows', rows);
    }
  }, [rows]);

  return (
    <>
      <div className="table-container">
        <Table className="interactive" compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    textAlign="center"
                  >
                    <Filter column={column} selectedStatus={selectedStatus} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign="center" {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePagination
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default QueryTable;
